import { styled } from '../../../../../packages/theme/stitches.config';

const TennisMatchContainer = styled.withConfig({ componentId: 'TennisWidget', displayName: 'TennisEventRowContainer' })('div', {
  mb: '1px',
  variants: {
    variant: {
      base: {},
      live: {
        position: 'relative',
        '&::before': {
          content: '',
          width: '4px',
          top: '12%',
          height: '75%',
          background: '$liveMatchStatusColor',
          position: 'absolute',
          borderRadius: '0 $3 $3 0',
        },
      },
    },
    type: {
      livescore: {
        bc: '$rowBackgroundColor',
        mb: '1px',
      },
      singleEvent: {
        bc: '$diffContrastColor',
        mb: '3px',
      },
    },
  },
});

export default TennisMatchContainer;
